const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let loaderPromise = null;

/**
 * Loads the Turnstile script once per page, no matter how many widgets ask for
 * it. StrictMode mounts every effect twice in development, so the shared
 * promise is what stops a second <script> tag being appended.
 */
export function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (loaderPromise) {
    return loaderPromise;
  }

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => {
      // Allow a later mount to retry rather than caching the failure forever.
      script.remove();
      loaderPromise = null;
      reject(new Error('Turnstile script failed to load'));
    };

    document.head.appendChild(script);
  });

  return loaderPromise;
}

export default loadTurnstile;
